enum ActivityStatusDate {
  Start = "START",
  NoStart = "NO_START",
  NoStartAndDelayed = "NO_START_AND_DELAYED",
  StartOnTime = "START_ON_TIME",
  StartAndDelayed = "START_AND_DELAYED",
  Executed = "EXECUTED",
  Cancelled = "CANCELED",
}

export default ActivityStatusDate;
